const tr = {
  packageActives: {
    attributes: {
      id: 'ID',
      name: 'Nome',
      cpf: 'CPF',
      cell_phone: 'Telefone',
      email: 'E-mail',
      corporation: 'Empresa',
      pack: 'Adicional',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      considerBranches: 'Considerar filiais',
      considerAllBranches: 'Considerar todas filiais',
      consider: 'Considerar',
      pack: 'Adicional',
    },
    defSingular: 'Relatório de adicionais ativos por empresa',
  },
};

export default tr;
